'use strict';

const { h, render } = require('phy');
const SelectWidgetContainer = require('../components/select_widget_container');

const renderWidget = {
  init({ selectWidget }, done) {
    if (!selectWidget) {
      done();
    }

    const container = document.querySelector('#select-widget-container');

    return render(
      h(SelectWidgetContainer, selectWidget.props),
      container,
      container.lastChild
    );
  },
};

module.exports = renderWidget;
